import { __assign } from "tslib";
import React, { useCallback } from 'react';
import { Head, TableHeader } from './header.styles';
export var Header = function (_a) {
    var headerGroups = _a.headerGroups, typography = _a.typography, color = _a.color, editMode = _a.editMode, _b = _a.activeColumns, activeColumns = _b === void 0 ? [] : _b, onCellMouseEnter = _a.onCellMouseEnter, onCellMouseLeave = _a.onCellMouseLeave, onEditModeClick = _a.onEditModeClick, columnsNamesMapping = _a.columnsNamesMapping;
    var getColumnName = useCallback(function (columnName) {
        if (columnsNamesMapping === null || columnsNamesMapping === void 0 ? void 0 : columnsNamesMapping[columnName])
            return columnsNamesMapping === null || columnsNamesMapping === void 0 ? void 0 : columnsNamesMapping[columnName];
        return columnName;
    }, [columnsNamesMapping]);
    return (React.createElement(Head, { typography: typography, backgroundColor: color }, headerGroups.map(function (headerGroup) { return (React.createElement("tr", { key: headerGroup.getHeaderGroupProps().key }, headerGroup.headers.map(function (column, idx) {
        var align = column.align, isSorted = column.isSorted, isSortedDesc = column.isSortedDesc, columnId = column.id;
        var _a = column.getHeaderProps(column.getSortByToggleProps()), key = _a.key, title = _a.title, onClick = _a.onClick;
        return (React.createElement(TableHeader, __assign({ isDisabled: column.type === 'row-selection' && editMode, key: key }, (column.type === 'value'
            ? {
                title: title,
                isActive: activeColumns.includes(idx),
                onClick: function (e) {
                    return onEditModeClick
                        ? onEditModeClick(e, columnId, idx)
                        : onClick(e);
                },
                onMouseEnter: function (e) {
                    return onCellMouseEnter && onCellMouseEnter(e, idx);
                },
                onMouseLeave: function (e) {
                    return onCellMouseLeave && onCellMouseLeave(e, idx);
                },
            }
            : {})), column.render('Header', {
            textAlignment: align,
            isSorted: isSorted,
            isSortedDescending: isSortedDesc,
            editMode: editMode,
            columnName: getColumnName(columnId),
        })));
    }))); })));
};
